function refreshPage() {
  console.log("test");
  return window.location.reload();
}

export default refreshPage;
